import React, { useRef } from 'react'
import './styles.scss'
import { config } from './config'

interface Props {
  locales: { deactivate: string; activate: string }
  current: boolean
  toggle: (current: boolean) => void
}

export const MapActivationButton = ({ current, toggle, locales }: Props) => {
  const bElement = useRef<HTMLButtonElement | null>(null)
  return (
    <button
      ref={bElement}
      className={'mapactivationbutton' + (current ? ' scroll' : '')}
      onClick={() => {
        let search: HTMLDivElement = document.getElementsByClassName(
          'ui text container nominatim'
        )[0] as HTMLDivElement

        window.scrollTo({
          left: 0,
          top: search.offsetTop,
          behavior: 'smooth'
        })

        toggle(!current)
      }}
    >
      {locales[current ? 'deactivate' : 'activate']}
    </button>
  )
}
